const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

let onUnauthorized = null;

export function setOnUnauthorized(callback) {
    onUnauthorized = callback;
}

export async function authFetch(endpoint, options = {}) {
    const { skipAuth, ...fetchOptions } = options;
    const headers = { ...(fetchOptions.headers || {}) };

    if (!skipAuth) {
        const token = localStorage.getItem('token');
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }
    }
    headers['Content-Type'] = headers['Content-Type'] || 'application/json';

    const newOptions = {
        ...fetchOptions,
        headers
    };

    const response = await fetch(`${API_URL}${endpoint}`, newOptions);

    if (response.status === 401 && onUnauthorized) {
        if (!endpoint.includes('/auth/login')) {
            onUnauthorized();
        }
    }

    return response;
}

export async function registerUser(username, password) {
    const response = await authFetch(`/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    });
    return response.json();
}

export async function loginUser(username, password) {
    const response = await authFetch(`/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    });
    return response.json();
}

export async function getItems(params = {}) {
    let query = new URLSearchParams(params).toString();
    const response = await authFetch(`/catalog/?${query}`);
    return response.json();
}

export async function getCart(token) {
    const response = await authFetch(`/cart/`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.json();
}

export async function addToCart(token, item_id, quantity = 1) {
    const response = await authFetch(`/cart/add`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ item_id, quantity })
    });
    return response.json();
}

export async function removeFromCart(token, item_id) {
    const response = await authFetch(`/cart/remove`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ item_id })
    });
    return response.json();
}

export async function createOrder(token) {
    const response = await authFetch(`/orders/`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
    return response.json();
}

export async function getOrders(token) {
    const response = await authFetch(`/orders/`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.json();
}

export async function getOrder(token, orderId) {
    const response = await authFetch(`/orders/${orderId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.json();
}
